__turbopack_context__.v({
  "bubble": "DealerLogo-module__LwIzQG__bubble",
  "noImage": "DealerLogo-module__LwIzQG__noImage",
});
